import React from 'react'
import { Hide, Container } from 'pcln-design-system'
import {
  useContentful,
  ISilhouetteMarketingModuleType,
  ICollectionType,
  ISpotlightCollection
} from '@pcln/contentful-components'
import { SilhouetteMarketingModule } from '@pcln/marketing'
import PromoBanners from '@/components/MerchModuleWrapper/PromoBanners'
import AdBanner from '@/components/AdBanner'
import WhyPricelineBanner from '@/components/WhyPricelineBanner/WhyPricelineBanner'
import PopularDestinations from '@/components/PopularDestinations'
import CreditCard from '@/components/CreditCard/CreditCard'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import EmailSignUp from '@/components/EmailSignUp'
import PromoFeatureBox from '@/components/PromoFeatureBox'
import useExpressDealDialog from '@/hooks/useExpressDealDialog'
import MarketingTout from '@/components/Promos/MarketingTout/MarketingTout'
import { REASONS_HOME } from '@/constants/reasons'
import { CustomMerchModule } from '@/types'
import mapSilhouetteContentfulData from '@/shared-utils/map-silhouette-contentful-data'
import mapSpotlightCollectionContentfulData from '@/components/SpotlightCollection/map-spotlight-contentful-data'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import IncredibleTile from '@/components/Promos/IncredibleTile'
import VIP from '@/components/Promos/VIP'
import PriceBreakers from '@/components/Promos/Pricebreakers'
import AppDownloadOptIn from '@/components/AppDownloadOptIn'
import useBootstrapData from '@/hooks/useBootstrapData'
import SpotlightCollection from '@/components/SpotlightCollection'
import PackagesCarousel from '@/components/PackagesCarousel'
import ExpressDealDialog from '@/components/Hotels/ExpressDeal/ExpressDealDialog'
import TripDisplayOrder from './TripDisplayOrder'

const expressDealQSKey = 'expressdeal'
const expressDealQSValue = 'y'

function AdBannerContent() {
  return (
    <AdBanner>
      <div id="div-gpt-ad-1614716188275-0" />
    </AdBanner>
  )
}

export default function HomeContent() {
  const {
    signInStatus: { signedIn }
  } = useBootstrapData()
  const { isOpen, closeDialog } = useExpressDealDialog(
    expressDealQSKey,
    expressDealQSValue
  )
  const spotlightCollectionContentfulData =
    useContentfulVariation<ISpotlightCollection>('spotlightCollection')

  const mappedSpotlightCollectionData =
    spotlightCollectionContentfulData &&
    mapSpotlightCollectionContentfulData(spotlightCollectionContentfulData)

  const promoCollection = useContentful('promoCollection') as ICollectionType
  const promoItems = (promoCollection?.items ||
    []) as ReadonlyArray<CustomMerchModule>

  const silhouetteContentfulData =
    useContentfulVariation<ISilhouetteMarketingModuleType>(
      'silhouetteMarketingModule'
    )
  const mappedSilhouetteData = mapSilhouetteContentfulData(
    silhouetteContentfulData,
    ANALYTICS_CATEGORY_HOME
  )

  return (
    <Container size="xl" mb={5}>
      <ExpressDealDialog
        isOpen={isOpen}
        closeDialog={closeDialog}
        gaCategory={ANALYTICS_CATEGORY_HOME}
      />
      {mappedSpotlightCollectionData && (
        <SpotlightCollection spotlightData={mappedSpotlightCollectionData} />
      )}

      <TripDisplayOrder />

      <Hide md>
        <PromoFeatureBox>
          {signedIn ? <VIP /> : <PriceBreakers />}
          <IncredibleTile contentFulFieldID="incredibleTile" />
        </PromoFeatureBox>
      </Hide>
      <AppDownloadOptIn />
      <MarketingTout />
      {mappedSilhouetteData && (
        <SilhouetteMarketingModule {...mappedSilhouetteData} />
      )}
      <PackagesCarousel
        heading="Don't miss these hotel + flight deals"
        gaCategory={ANALYTICS_CATEGORY_HOME}
      />
      <EmailSignUp sourceId="LANDING_HOME" category={ANALYTICS_CATEGORY_HOME} />
      <PopularDestinations />
      <PromoBanners merchModules={promoItems} />
      <CreditCard />
      <WhyPricelineBanner content={REASONS_HOME} />
      <AdBannerContent />
    </Container>
  )
}
